import { type GuideMetadata } from '../types';

const metadata: Readonly<GuideMetadata> = Object.freeze({
  name: 'Spring Boot',
  description: 'Spring Boot is an open source Java-based framework used to create a micro Service.',
  target: 'API',
});

export default metadata;
